// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* gantt-styles.css */
.demo {
  overflow: hidden;
  height: 100%;
}

/* Style rules for the "narrow" type */
.demo > .wx-gantt .wx-bar.wx-task.narrow {
  background-color: #676a81;
  color: transparent;
  height: 10px !important;
  margin-top: 10px;
  border: 1px solid #63667a;
}
.demo > .wx-gantt .wx-bar.wx-task.narrow .wx-progress-percent {
  background-color: #1a2630;
}
.demo > .wx-gantt .wx-bar.wx-task.narrow .wx-link {
  background-color: #384047;
  border-radius: 0px;
}
.demo > .wx-gantt .wx-bar.wx-task.narrow .wx-link .wx-inner {
  border-radius: 0px;
}

.demo > .wx-gantt .wx-progress-percent {
  background-color: #ffc107;
}

/* Style rules for the "progress" type */
.demo > .wx-gantt .wx-bar.wx-task.progress {
  background-color: transparent;
  color: var(--wx-color-font);
  border-radius: 50px;
  border: 1px solid #00bcd4;
}
.demo > .wx-gantt .wx-bar.wx-task.progress .wx-progress-percent {
  background-color: #00bcd4;
}
.demo > .wx-gantt .wx-bar.wx-task.progress .wx-progress-wrapper {
  border-radius: 50px;
}

/* Style rules for the "urgent" type */
.demo > .wx-gantt .wx-bar.wx-task.task {
  background-color: #f49a82;
  border: 1px solid #f45e36;
}
.demo > .wx-gantt .wx-bar.wx-task.task .wx-progress-percent {
  background-color: #f45e36;
}
.demo .wx-cell .wx-text-left .x2-1wbpy33{
  width: 309px !important;
  min-width: 309px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/NPD/SVARGantt/styles.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B","sourcesContent":["/* gantt-styles.css */\n.demo {\n  overflow: hidden;\n  height: 100%;\n}\n\n/* Style rules for the \"narrow\" type */\n.demo > .wx-gantt .wx-bar.wx-task.narrow {\n  background-color: #676a81;\n  color: transparent;\n  height: 10px !important;\n  margin-top: 10px;\n  border: 1px solid #63667a;\n}\n.demo > .wx-gantt .wx-bar.wx-task.narrow .wx-progress-percent {\n  background-color: #1a2630;\n}\n.demo > .wx-gantt .wx-bar.wx-task.narrow .wx-link {\n  background-color: #384047;\n  border-radius: 0px;\n}\n.demo > .wx-gantt .wx-bar.wx-task.narrow .wx-link .wx-inner {\n  border-radius: 0px;\n}\n\n.demo > .wx-gantt .wx-progress-percent {\n  background-color: #ffc107;\n}\n\n/* Style rules for the \"progress\" type */\n.demo > .wx-gantt .wx-bar.wx-task.progress {\n  background-color: transparent;\n  color: var(--wx-color-font);\n  border-radius: 50px;\n  border: 1px solid #00bcd4;\n}\n.demo > .wx-gantt .wx-bar.wx-task.progress .wx-progress-percent {\n  background-color: #00bcd4;\n}\n.demo > .wx-gantt .wx-bar.wx-task.progress .wx-progress-wrapper {\n  border-radius: 50px;\n}\n\n/* Style rules for the \"urgent\" type */\n.demo > .wx-gantt .wx-bar.wx-task.task {\n  background-color: #f49a82;\n  border: 1px solid #f45e36;\n}\n.demo > .wx-gantt .wx-bar.wx-task.task .wx-progress-percent {\n  background-color: #f45e36;\n}\n.demo .wx-cell .wx-text-left .x2-1wbpy33{\n  width: 309px !important;\n  min-width: 309px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
